export enum ErrorStatus {
    GlobalExeption=1,
    ValidationException=2,
    Unauthorized=3,
    CRExpiry=4
}
